import React, { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import DroitscoDetails from "./JuridiquePonctuelle/droitsocDetails";
import ModificationSociete from "./JuridiquePonctuelle/modificationSociete";
import CreateSociete from "./JuridiquePonctuelle/CreateSociete";
import Radiation from "./JuridiquePonctuelle/Radiation";
import Autre from "./JuridiquePonctuelle/autres.js";
import FicheClientOverlay from "../../Portefeuille/FicheClientOverlay";
import { useClient } from "../../Portefeuille/useClients.js";
import { AiOutlineDelete } from "react-icons/ai";
import Mission from "../../Mission/Mission.js";
import { IoIosSearch } from "react-icons/io";
import { CiFilter } from "react-icons/ci";
import { useMemo, useRef } from "react";
import { HiMiniArchiveBox } from "react-icons/hi2";
import { useEtatGlobal } from "../../EtatGlobal.js";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";

import {
  ChevronDown,
  AlertCircle,
  Plus,
  Archive,
  ChartSpline,
  Scale,
  X,
  Building2,
  User,
  Briefcase,
  Calendar,
} from "lucide-react";
import { isPast, parseISO } from "date-fns";
import { authFetch } from "../../../HttpClient";

import { dialog } from "../../../components/ui/Dialog";
import { estBloque } from "./suiviProdUtils";
import BadgeBloque from "./BadgeBloque";
const JuridiquePonctuelle = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedSource, setSelectedSource] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [collapsedStatuses, setCollapsedStatuses] = useState({});

  const [showAddDiv, setshowAddDiv] = useState(false);

  const [showArchives, setShowArchives] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isArchiving, setIsArchiving] = useState(false);
  const [isDesArchiving, setIsDesArchiving] = useState(false);
  const [activeStatusFilter, setActiveStatusFilter] = useState(null);

  const toggleSelectItem = (item) => {
    const key = `${item.source}-${item.id}`;

    setSelectedItems((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  };

  const getItemUrl = (item) => {
    switch (item.source) {
      case "modifsct":
        return `https://backend-myalfa.vercel.app/api/modifsct/${item.id}`;
      case "droitsoc":
        return `https://backend-myalfa.vercel.app/api/droitsoc/${item.id}`;
      case "creationsct":
        return `https://backend-myalfa.vercel.app/api/creation-sct/${item.id}`;
      case "radiation":
        return `https://backend-myalfa.vercel.app/api/Radiation/${item.id}`;
      case "autresMission":
        return `https://backend-myalfa.vercel.app/api/autresMission/${item.id}`;
      default:
        return null;
    }
  };

  const updateItemStatus = async (item, newStatus) => {
    const url = getItemUrl(item);
    if (!url) return;

    try {
      await authFetch(url, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ status: newStatus }),
      });
    } catch (error) {
      console.error("Erreur update status !!!", error);
    }
  };

  const onDragEnd = async (result) => {
    const { source, destination, draggableId } = result;

    if (!destination) return;

    const sourceStatus = source.droppableId;
    const destStatus = destination.droppableId;

    // ❌ Même statut → on ne fait rien
    if (sourceStatus === destStatus) return;

    // Trouver l’item déplacé
    const movedItem = data.find(
      (item) => `${item.source}-${item.id}` === draggableId
    );

    if (!movedItem) return;

    // ✅ Mise à jour immédiate de l’UI
    setData((prev) =>
      prev.map((item) =>
        item.id === movedItem.id && item.source === movedItem.source
          ? { ...item, status: destStatus }
          : item
      )
    );

    // 🔄 Appel API en arrière-plan
    updateItemStatus(movedItem, destStatus);
  };

  const [showFilterOverlay, setShowFilterOverlay] = useState(false);
  const [filterRows, setFilterRows] = useState([
    { column: "missionLabel", selectedValues: [] },
  ]);
  const overlayRef = useRef(null);

  // Overlay dossier lead (les creationsct sont liés à un formLead, pas à un client)
  const [overlayDossier, setOverlayDossier] = useState(null);
  const [dossierType, setDossierType] = useState(null);
  const overlayDossierRef = useRef(null);
  const inoverlayDossierRef = useRef(null);

  // Fiche client — même cache React Query partagé que Portefeuille.js
  // (["client", id] / ["clients"]) au lieu d'un fetch + cache local isolé :
  // ainsi une édition faite ici (via Update.js) se reflète instantanément
  // dans Portefeuille.js et vice-versa.
  const queryClient = useQueryClient();
  const [ficheClientOpen, setFicheClientOpen] = useState(false);
  const [selectedClientId, setSelectedClientId] = useState(null);
  const { data: ficheClientDetail, isLoading: ficheClientLoading } =
    useClient(selectedClientId);

  const {
    juridiquePonctuelleData: data,
    setJuridiquePonctuelleData: setData,

    fetchJuridiquePonctuelle: fetchData,
    utilisateur,
  } = useEtatGlobal();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (overlayRef.current && !overlayRef.current.contains(e.target)) {
        setShowFilterOverlay(false);
      }
    };

    if (showFilterOverlay)
      document.addEventListener("mousedown", handleClickOutside);
    else document.removeEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showFilterOverlay]);

  const uniqueValues = useMemo(() => {
    const dict = {
      missionLabel: [],
      status: [],
      priority: [],
    };

    data.forEach((item) => {
      if (item.missionLabel) dict.missionLabel.push(item.missionLabel);
      if (item.status) dict.status.push(item.status);
      if (item.priority) dict.priority.push(item.priority);
    });

    Object.keys(dict).forEach((key) => {
      dict[key] = [...new Set(dict[key])]; // supprime doublons
    });

    return dict;
  }, [data]);

  const filteredData = useMemo(() => {
    return data.filter((item) => {
      // Appliquer le filtre par nom ou autre filtre avancé
      const passesAdvancedFilters = filterRows.every((filter) => {
        if (!filter.selectedValues || filter.selectedValues.length === 0)
          return true;

        const val =
          filter.column === "date"
            ? item.date
              ? new Date(item.date).toLocaleDateString("fr-FR")
              : ""
            : item[filter.column];

        return filter.selectedValues.includes(val);
      });

      return passesAdvancedFilters;
    });
  }, [data, filterRows]);

  // Filtre activeStatusFilter appliqué uniquement sur la liste accordéon
  const tableData = useMemo(() => {
    if (!activeStatusFilter) return filteredData;
    return filteredData.filter((item) => item.status === activeStatusFilter);
  }, [filteredData, activeStatusFilter]);

  // Les missions d'un dossier bloqué (litige) restent dans le tableau, grisées,
  // mais ne comptent dans aucune carte de statistiques.
  const kpiData = useMemo(
    () => filteredData.filter((i) => !estBloque(i.client)),
    [filteredData],
  );

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    return new Date(dateStr).toLocaleDateString("fr-FR");
  };

  const handleRowClick = (item) => {
    setSelectedItem(item);
    setSelectedSource(item.source);
    setShowDetails(true);
  };

  const handleCloseDetails = () => {
    setShowDetails(false);
  };

  const showClientDetails = (client) => {
    setSelectedClientId(client.id);
    setFicheClientOpen(true);
  };

  // En attendant que useClient(selectedClientId) réponde, on affiche tout de
  // suite le snapshot déjà embarqué dans l'item (mêmes états que
  // Portefeuille.js : détail React Query prioritaire, fallback liste).
  const ficheClientFallback =
    data.find((d) => d.client?.id === selectedClientId)?.client || null;
  const ficheClientData = ficheClientDetail || ficheClientFallback;

  // Propage une édition (nom, groupement, collaborateur...) vers le cache
  // React Query partagé — même mécanique que handleUpdateUserInList dans
  // Portefeuille.js — pour que Portefeuille.js et toute autre FicheClientOverlay
  // ouverte ailleurs reflètent instantanément le changement.
  const handleUpdateClientInList = (updatedClient) => {
    queryClient.setQueryData(["client", updatedClient.id], updatedClient);
    queryClient.setQueryData(["clients"], (prev) =>
      Array.isArray(prev)
        ? prev.map((c) => (c.id === updatedClient.id ? updatedClient : c))
        : prev
    );
  };

  const handleDossierClick = (item, e) => {
    e.stopPropagation();

    if (item.source === "creationsct") {
      // Les créations de société sont liées à un lead, pas à un client
      if (item.formLead) {
        setDossierType("lead");
        setOverlayDossier(item.formLead);
      } else {
        // Ni lead ni client : dossier hors base, on affiche les infos du formulaire
        setDossierType("inconnu");
        setOverlayDossier(item);
      }
      return;
    }
    if (item.client) {
      showClientDetails(item.client);
    }
  };

  const updateLocalData = (itemId, source, updates) => {
    setData((prev) =>
      prev.map((d) =>
        d.id === itemId && d.source === source ? { ...d, ...updates } : d
      )
    );
  };

  const statusStyleConfig = {
    "En attente": {
      bg: "#FFFBEB",
      text: "#B45309",
      border: "#FDE68A",
      dot: "#8b6a0f",
    },

    "En attente informations / documents": {
      bg: "#FEF3C7",
      text: "#92400E",
      border: "#FDE68A",
      dot: "#8b6a0f",
    },

    "En attente interne": {
      bg: "#FFFBEB",
      text: "#78350F",
      border: "#FCD34D",
      dot: "#2c4fa1",
    },

    "Dépôt de capital en cours": {
      bg: "#FFF7ED",
      text: "#9A3412",
      border: "#FED7AA",
      dot: "#2c4fa1",
    },

    Rédaction: {
      bg: "#EFF6FF",
      text: "#1D4ED8",
      border: "#BFDBFE",
      dot: "#2c4fa1",
    },

    Supervision: {
      bg: "#EEF2FF",
      text: "#3730A3",
      border: "#C7D2FE",
      dot: "#2c4fa1",
    },

    Signature: {
      bg: "#F5F3FF",
      text: "#6D28D9",
      border: "#DDD6FE",
      dot: "#8b6a0f",
    },

    "Signature en cours": {
      bg: "#F3E8FF",
      text: "#7E22CE",
      border: "#E9D5FF",
      dot: "#8b6a0f",
    },

    Formalité: {
      bg: "#ECFEFF",
      text: "#0E7490",
      border: "#A5F3FC",
      dot: "#2c4fa1",
    },

    "Formalité déposée": {
      bg: "#E0F2FE",
      text: "#0369A1",
      border: "#BAE6FD",
      dot: "#2a6d3c",
    },

    "Formalité à régulariser": {
      bg: "#FEF9C3",
      text: "#854D0E",
      border: "#FDE047",
      dot: "#b43a3a",
    },

    "Formalité rejetée": {
      bg: "#FEE2E2",
      text: "#991B1B",
      border: "#FECACA",
      dot: "#EF4444",
    },

    Bloqué: {
      bg: "#FEE2E2",
      text: "#B91C1C",
      border: "#FCA5A5",
      dot: "#EF4444",
    },

    Abandonné: {
      bg: "#F1F5F9",
      text: "#475569",
      border: "#CBD5F5",
      dot: "#94A3B8",
    },

    Terminé: {
      bg: "#ECFDF5",
      text: "#047857",
      border: "#A7F3D0",
      dot: "#2a6d3c",
    },

    "Sans statut": {
      bg: "#F8FAFC",
      text: "#64748B",
      border: "#E2E8F0",
      dot: "#94A3B8",
    },
    Archiver: {
      bg: "#F8FAFC",
      text: "#64748B",
      border: "#E2E8F0",
      dot: "#94A3B8",
    },
  };

  const handleMultiDelete = async () => {
    if (selectedItems.length === 0) return;

    // Confirmation AVANT de passer en état "Suppression..." — sinon un refus
    // laissait le bouton bloqué pour toujours
    const confirmDelete = await dialog.confirm(
      `Voulez-vous vraiment supprimer ${selectedItems.length} élément(s) ?`
    );
    if (!confirmDelete) return;

    setIsDeleting(true);
    const keys = [...selectedItems];

    // UI instantanée : les lignes disparaissent tout de suite
    setData((prev) =>
      prev.filter((item) => !keys.includes(`${item.source}-${item.id}`))
    );
    setSelectedItems([]);

    try {
      await Promise.all(
        keys.map((key) => {
          const [source, idStr] = key.split("-");
          const id = Number(idStr);

          const url = getItemUrl({ source, id });
          if (!url) {
            console.warn("URL introuvable pour", source, id);
            return null;
          }

          return authFetch(url, { method: "DELETE" });
        })
      );
    } catch (err) {
      console.error("Erreur suppression multiple :", err);
      fetchData(); // resynchronise l'état réel
      dialog.alert("Erreur lors de la suppression multiple.");
    } finally {
      setIsDeleting(false);
    }
  };

  const handleMultiArchive = async () => {
    if (selectedItems.length === 0) return;

    // Confirmation AVANT de passer en état "Archivage..." — sinon un refus
    // laissait le bouton bloqué pour toujours
    const confirmArchive = await dialog.confirm(
      `Voulez-vous archiver ${selectedItems.length} élément(s) ?`
    );
    if (!confirmArchive) return;

    setIsArchiving(true);
    const keys = [...selectedItems];
    // Conserve le statut d'origine de chaque item avant la bascule optimiste
    const itemsByKey = Object.fromEntries(
      keys.map((key) => {
        const [source, idStr] = key.split("-");
        const id = Number(idStr);
        return [key, data.find((d) => d.id === id && d.source === source)];
      })
    );

    // UI instantanée : les lignes partent aux archives tout de suite
    setData((prev) =>
      prev.map((item) =>
        keys.includes(`${item.source}-${item.id}`)
          ? { ...item, lastStatus: item.status, status: "Archiver" }
          : item
      )
    );
    setSelectedItems([]);

    try {
      await Promise.all(
        keys.map((key) => {
          const item = itemsByKey[key];
          if (!item) {
            console.warn("Item introuvable 🛑", key);
            return null;
          }

          const url = getItemUrl(item);
          if (!url) {
            console.warn("URL introuvable", item);
            return null;
          }

          return authFetch(url, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              status: "Archiver",
              lastStatus: item.status,
            }),
          });
        })
      );
    } catch (err) {
      console.error("Erreur lors de l'archivage multiple :", err);
      fetchData(); // resynchronise l'état réel
      dialog.alert("Erreur lors de l'archivage multiple.");
    } finally {
      setIsArchiving(false);
    }
  };

  const handleMultiUnarchive = async () => {
    if (selectedItems.length === 0) return;

    // Confirmation AVANT de passer en état "Désarchivage..." — sinon un refus
    // laissait le bouton bloqué pour toujours
    const confirmUnarchive = await dialog.confirm(
      `Voulez-vous désarchiver ${selectedItems.length} élément(s) ?`
    );
    if (!confirmUnarchive) return;

    setIsDesArchiving(true);
    const keys = [...selectedItems];
    const itemsByKey = Object.fromEntries(
      keys.map((key) => {
        const [source, idStr] = key.split("-");
        const id = Number(idStr);
        return [key, data.find((d) => d.id === id && d.source === source)];
      })
    );

    // UI instantanée : les lignes retrouvent leur statut tout de suite
    setData((prev) =>
      prev.map((item) =>
        keys.includes(`${item.source}-${item.id}`)
          ? {
              ...item,
              status: item.lastStatus || "En attente",
              lastStatus: null,
            }
          : item
      )
    );
    setSelectedItems([]);

    try {
      await Promise.all(
        keys.map((key) => {
          const item = itemsByKey[key];
          if (!item) {
            console.warn("Item introuvable 🛑", key);
            return null;
          }

          const url = getItemUrl(item);
          if (!url) {
            console.warn("URL introuvable", item);
            return null;
          }

          return authFetch(url, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              status: item.lastStatus || "En attente",
              lastStatus: null,
            }),
          });
        })
      );
    } catch (err) {
      console.error("Erreur lors du désarchivage :", err);
      fetchData(); // resynchronise l'état réel
      dialog.alert("Erreur lors du désarchivage.");
    } finally {
      setIsDesArchiving(false);
    }
  };

  // Nom affiché pour un dossier — même règle partout (recherche, tri, colonne
  // "Dossier") pour que le tri ne puisse jamais diverger de ce qui est affiché.
  const getDossierName = (item) =>
    item.source === "creationsct"
      ? item.nomSociete ||
        [item.formLead?.nom, item.formLead?.prenom]
          .filter(Boolean)
          .join(" ")
          .trim() ||
        "-"
      : item.client?.nom || "-";

  const groupDataByStatus = (items) => {
    const statusMap = {};
    items.forEach((item) => {
      const statusKey = item.status || "Sans statut";
      if (!statusMap[statusKey]) {
        statusMap[statusKey] = [];
      }
      statusMap[statusKey].push(item);
    });
    // Tri stable et déterministe : sans backend `orderBy` sur droitsoc/
    // radiation/autresMission, l'ordre de retour n'est pas garanti et pouvait
    // silencieusement changer après un refetch (déclenché par n'importe quelle
    // sauvegarde ailleurs dans l'app) — au clic, la ligne à l'écran ne
    // correspondait alors plus au même dossier.
    Object.values(statusMap).forEach((group) => {
      group.sort((a, b) =>
        getDossierName(a).localeCompare(getDossierName(b), "fr", {
          sensitivity: "base",
        })
      );
    });
    return statusMap;
  };

  const statusOrder = [
    "En attente",
    "En attente informations / documents",
    "En attente interne",
    "Dépôt de capital en cours",
    "Rédaction",
    "Supervision",
    "Signature",
    "Signature en cours",
    "Formalité",
    "Formalité déposée",
    "Formalité à régulariser",
    "Formalité rejetée",
    "Bloqué",
    "Abandonné",
    "Terminé",
    "Sans statut", // au cas où
  ];

  const toggleStatusCollapse = (statusKey) => {
    setCollapsedStatuses((prev) => ({
      ...prev,
      [statusKey]: !(prev[statusKey] ?? true),
    }));
  };

  const normalize = (str) =>
    (str || "")
      .toLowerCase()
      .trim()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div style={{ marginRight: "2%" }}>
        <>
          {/* Header */}
          <div className="flex items-center justify-between gap-4 mb-5">
            <div className="relative flex-1 max-w-sm">
              <IoIosSearch className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <input
                type="text"
                placeholder="Filtrer par nom du dossier..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
                className="pl-9 h-9 w-full rounded-md bg-slate-50 border border-slate-200 text-sm focus:bg-white focus:outline-none"
              />
            </div>
            <div className="flex items-center gap-3">
              <button
                onClick={() => setShowArchives(!showArchives)}
                className={`flex items-center gap-2 h-8 px-3 rounded-md font-semibold text-sm ${
                  showArchives
                    ? "bg-slate-100 text-black border border-slate-300"
                    : "bg-white text-black border border-slate-300 hover:bg-slate-50"
                }`}
              >
                <Archive className="w-3 h-3" />
                {showArchives ? "Retour" : "Archive"}
              </button>
              <button
                onClick={() => setShowFilterOverlay(!showFilterOverlay)}
                className="flex items-center gap-2 h-8 px-3 rounded-md font-semibold text-sm bg-white text-black border border-slate-300 hover:bg-slate-50"
              >
                <CiFilter className="w-3 h-3" />
                Filtrer
              </button>
              <button
                onClick={() => setshowAddDiv(!showAddDiv)}
                className="flex items-center gap-2 h-9 px-4 rounded-md font-semibold text-white bg-slate-700 hover:bg-slate-800 text-sm"
              >
                <Plus className="w-3.5 h-3.5" />
                Nouvelle mission
              </button>
            </div>
          </div>

          {/* Panneau filtres avancés */}
          {showFilterOverlay && (
            <div
              ref={overlayRef}
              className="bg-white border border-slate-200 rounded-lg p-4 shadow-sm mb-4"
            >
              <div className="flex justify-between mb-2">
                <p className="font-semibold">Filtres avancés</p>
                <button
                  onClick={() =>
                    setFilterRows([
                      { column: "missionLabel", selectedValues: [] },
                    ])
                  }
                  className="text-sm text-slate-600 hover:text-slate-800"
                >
                  Réinitialiser
                </button>
              </div>
              {filterRows.map((f, idx) => (
                <div key={idx} className="mb-3">
                  <div className="flex items-center justify-between mb-1">
                    <select
                      value={f.column}
                      onChange={(e) =>
                        setFilterRows((prev) =>
                          prev.map((row, i) =>
                            i === idx
                              ? {
                                  ...row,
                                  column: e.target.value,
                                  selectedValues: [],
                                }
                              : row
                          )
                        )
                      }
                      className="border border-slate-200 rounded-md p-1 text-sm"
                    >
                      {Object.keys(uniqueValues).map((col) => {
                        const labelMap = {
                          missionLabel: "Mission",
                          status: "Statut",
                          priority: "Priorité",
                        };
                        return (
                          <option key={col} value={col}>
                            {labelMap[col] || col}
                          </option>
                        );
                      })}
                    </select>
                    <button
                      onClick={() =>
                        setFilterRows((prev) =>
                          prev.filter((_, i) => i !== idx)
                        )
                      }
                      className="text-sm text-red-600 hover:text-red-800"
                    >
                      Supprimer
                    </button>
                  </div>
                  <div className="flex flex-col ml-2">
                    {uniqueValues[f.column]?.map((val) => (
                      <label key={val} className="text-sm">
                        <input
                          type="checkbox"
                          checked={f.selectedValues.includes(val)}
                          onChange={() => {
                            const updated = f.selectedValues.includes(val)
                              ? f.selectedValues.filter((v) => v !== val)
                              : [...f.selectedValues, val];
                            setFilterRows((prev) =>
                              prev.map((row, i) =>
                                i === idx
                                  ? { ...row, selectedValues: updated }
                                  : row
                              )
                            );
                          }}
                          className="mr-2"
                        />
                        {val}
                      </label>
                    ))}
                  </div>
                </div>
              ))}
              <button
                onClick={() =>
                  setFilterRows([
                    ...filterRows,
                    { column: "missionLabel", selectedValues: [] },
                  ])
                }
                className="text-sm text-slate-700 hover:text-slate-900 mt-2"
              >
                + Ajouter un filtre
              </button>
            </div>
          )}

          {/* 2 cartes stats principales */}
          {!showArchives && (
            <div className="grid grid-cols-2 gap-4 mb-5 mt-4">
              <div className="bg-white rounded-xl p-5 border border-slate-100 shadow-sm flex items-center gap-4">
                <div className="w-10 h-10 bg-[#e5ebfa] rounded-lg flex items-center justify-center border border-slate-100">
                  <ChartSpline className="text-[#2c4fa1] w-5 h-5 font-light" />
                </div>
                <div>
                  <p className="text-xs text-[#8d7b83] mb-0.5 font-medium m-0">
                    Missions en cours
                  </p>
                  <div className="flex items-baseline gap-1.5">
                    <span className="text-2xl font-bold text-slate-900">
                      {
                        kpiData.filter(
                          (i) =>
                            i.status !== "Terminé" && i.status !== "Archiver"
                        ).length
                      }
                    </span>
                    <span className="text-base text-slate-400 font-medium">
                      /{" "}
                      {
                        kpiData.filter((i) => i.status !== "Archiver")
                          .length
                      }
                    </span>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-xl p-5 border border-slate-100 shadow-sm flex items-center gap-4">
                <div className="w-10 h-10 bg-[#fbe3e3] rounded-lg flex items-center justify-center border border-red-100">
                  <AlertCircle className="w-5 h-5 text-[#ba4848]" />
                </div>
                <div>
                  <p className="text-xs text-[#8d7b83] mb-0.5 font-medium m-0">
                    Missions en retard
                  </p>
                  <span className="text-2xl font-bold text-slate-900">
                    {
                      kpiData.filter(
                        (i) =>
                          i.dueDate &&
                          isPast(parseISO(i.dueDate)) &&
                          i.status !== "Terminé" &&
                          i.status !== "Archiver"
                      ).length
                    }
                  </span>
                </div>
              </div>
            </div>
          )}

          {/* Répartition par état */}
          {!showArchives &&
            (() => {
              const grouped = groupDataByStatus(
                kpiData.filter((i) => i.status !== "Archiver")
              );
              const totalMissions = kpiData.filter(
                (i) => i.status !== "Archiver"
              ).length;
              const statusCards = statusOrder.filter(
                (s) => grouped[s]?.length > 0
              );
              if (statusCards.length === 0) return null;
              return (
                <div className="bg-white rounded-xl border border-slate-100 shadow-sm p-5 mb-5">
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-sm font-semibold text-slate-900 flex items-center gap-2 m-0">
                      <Scale className="w-4 h-4" /> Répartition par état
                    </h3>
                    <div className="flex items-center gap-2">
                      {activeStatusFilter && (
                        <button
                          onClick={() => setActiveStatusFilter(null)}
                          className="text-xs text-slate-400 hover:text-slate-700 underline"
                        >
                          Tout afficher
                        </button>
                      )}
                      <span className="text-xs text-slate-400">
                        {totalMissions} missions au total
                      </span>
                    </div>
                  </div>
                  <div className="grid grid-cols-5 gap-3">
                    {statusCards.map((status) => {
                      const count = grouped[status].length;
                      const style =
                        statusStyleConfig[status] ||
                        statusStyleConfig["Sans statut"];
                      const isActive = activeStatusFilter === status;
                      return (
                        <button
                          key={status}
                          onClick={() =>
                            setActiveStatusFilter(isActive ? null : status)
                          }
                          className="rounded-lg px-3 pt-2.5 pb-3 relative overflow-hidden text-left transition-all"
                          style={{
                            backgroundColor: "#faf7f4",
                            border: isActive
                              ? `2px solid ${style.dot}`
                              : "1px solid #e8e0d8",
                            boxShadow: isActive
                              ? `0 0 0 2px ${style.dot}22`
                              : "none",
                          }}
                        >
                          <div className="flex items-center justify-between mb-2">
                            <div className="flex items-center gap-1.5 flex-1 min-w-0">
                              <div
                                className="w-2 h-2 rounded-full flex-shrink-0"
                                style={{ backgroundColor: style.dot }}
                              />
                              <span className="text-xs text-slate-600 leading-tight">
                                {status}
                              </span>
                            </div>
                            <span className="text-base font-bold ml-2 flex-shrink-0 text-slate-900">
                              {count}
                            </span>
                          </div>
                          <div
                            className="h-0.5 w-6 rounded-full"
                            style={{ backgroundColor: style.dot }}
                          />
                        </button>
                      );
                    })}
                  </div>
                </div>
              );
            })()}

          {/* Liste accordéon par statut */}
          <div className="space-y-1.5">
            {Object.entries(
              groupDataByStatus(
                tableData.filter((item) => {
                  const matchSearch = normalize(getDossierName(item)).includes(
                    normalize(searchTerm)
                  );
                  const isArchived = item.status === "Archiver";
                  return (
                    matchSearch && (showArchives ? isArchived : !isArchived)
                  );
                })
              )
            )
              .sort(
                ([a], [b]) => statusOrder.indexOf(a) - statusOrder.indexOf(b)
              )
              .map(([statusKey, statusItems]) => {
                const style =
                  statusStyleConfig[statusKey] ||
                  statusStyleConfig["Sans statut"];
                const isOpen = collapsedStatuses[statusKey] ?? true;
                return (
                  <div
                    key={statusKey}
                    className="bg-white rounded-xl border border-slate-100 overflow-hidden shadow-sm"
                  >
                    {/* Header accordéon */}
                    <div
                      onClick={() => toggleStatusCollapse(statusKey)}
                      className="flex items-center justify-between px-5 py-3.5 cursor-pointer hover:bg-slate-50/50 transition-colors"
                    >
                      <div className="flex items-center gap-3">
                        <div
                          className="w-2.5 h-2.5 rounded-full flex-shrink-0"
                          style={{ backgroundColor: style.dot }}
                        />
                        <span className="text-sm font-semibold text-slate-700">
                          {statusKey}
                        </span>
                        <span
                          className="text-xs font-bold px-2 py-0.5 rounded-full"
                          style={{
                            backgroundColor: "#f0ede9",
                            color: "#1e1e1e",
                            border: "1px solid #ddd8d2",
                          }}
                        >
                          {statusItems.length}
                        </span>
                      </div>
                      <ChevronDown
                        size={16}
                        className={`text-slate-400 transition-transform duration-200 ${
                          isOpen ? "" : "-rotate-90"
                        }`}
                      />
                    </div>

                    {/* Tableau (visible si ouvert) */}
                    {isOpen && (
                      <table
                        style={{
                          width: "99.5%",
                          margin: 0,
                          borderTop: "1px solid #f1f5f9",
                        }}
                      >
                        <thead>
                          <tr className="bg-[#6e1a36] border-b border-slate-100 p-5">
                            <th className="py-3.5 text-left w-[2%]"></th>
                            <th className="px-3 py-3.5 text-left text-xs font-semibold  text-white w-[18%]">
                              Dossier
                            </th>
                            <th className="px-3 py-2 text-left text-xs font-semibold  text-white w-[15%]">
                              Mission
                            </th>
                            <th className="px-3 py-2 text-left text-xs font-semibold  text-white w-[18%]">
                              Descriptif
                            </th>
                            <th className="px-3 py-2 text-left text-xs font-semibold  text-white w-[12%]">
                              Création
                            </th>
                            <th className="px-3 py-2 text-left text-xs font-semibold  text-white w-[12%]">
                              Échéance
                            </th>
                            <th className="px-3 py-2 text-left text-xs font-semibold  text-white w-[10%]">
                              Priorité
                            </th>
                            {["ADMINISTRATEUR", "EXPERT_COMPTABLE"].includes(
                              utilisateur.role
                            ) && (
                              <th className="px-3 py-2 text-left text-xs font-semibold  text-white w-[10%]">
                                Coefficient
                              </th>
                            )}
                          </tr>
                        </thead>
                        <Droppable droppableId={statusKey}>
                          {(provided) => (
                            <tbody
                              className="divide-y divide-slate-100"
                              ref={provided.innerRef}
                              {...provided.droppableProps}
                            >
                              {statusItems.map((item, index) => {
                                const isOverdue =
                                  item.dueDate &&
                                  isPast(parseISO(item.dueDate)) &&
                                  item.status !== "Terminé" &&
                                  item.status !== "Archivé" &&
                                  item.status !== "Archiver";
                                return (
                                  <Draggable
                                    key={`${item.source}-${item.id}`}
                                    draggableId={`${item.source}-${item.id}`}
                                    index={index}
                                  >
                                    {(provided, snapshot) => (
                                      <tr
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        onClick={() => handleRowClick(item)}
                                        className={`cursor-pointer transition-all text-xs ${
                                          estBloque(item.client) ? "ligne-bloquee " : ""
                                        }${
                                          snapshot.isDragging
                                            ? "shadow-xl bg-white"
                                            : ""
                                        } ${
                                          isOverdue
                                            ? "bg-red-50 hover:bg-red-100 border-l-2 border-l-red-400"
                                            : "hover:bg-slate-50/50"
                                        }`}
                                      >
                                        <td className="px-2 py-3.5">
                                          <input
                                            type="checkbox"
                                            checked={selectedItems.includes(
                                              `${item.source}-${item.id}`
                                            )}
                                            onChange={() =>
                                              toggleSelectItem(item)
                                            }
                                            onClick={(e) => e.stopPropagation()}
                                            className="w-3 h-3"
                                          />
                                        </td>
                                        <td className="px-3 py-2 font-semibold text-slate-800">
                                          <div className="flex items-center justify-between gap-2 w-full">
                                            <div className="flex items-center gap-1.5 min-w-0">
                                              {isOverdue && (
                                                <AlertCircle className="w-3 h-3 text-red-500 flex-shrink-0" />
                                              )}
                                              <span
                                                onClick={(e) =>
                                                  handleDossierClick(item, e)
                                                }
                                                className={`cursor-pointer hover:text-[#9B1B5D] hover:underline transition-colors truncate ${
                                                  isOverdue
                                                    ? "text-red-900"
                                                    : ""
                                                }`}
                                              >
                                                {getDossierName(item)}
                                              </span>
                                              {estBloque(item.client) && (
                                                <BadgeBloque />
                                              )}
                                            </div>
                                            {item.status &&
                                              (() => {
                                                const badgeStyle =
                                                  statusStyleConfig[
                                                    item.status
                                                  ] ||
                                                  statusStyleConfig[
                                                    "Sans statut"
                                                  ];
                                                const label =
                                                  item.status.length > 20
                                                    ? item.status.slice(0, 20) +
                                                      "…"
                                                    : item.status;
                                                return (
                                                  <span
                                                    title={item.status}
                                                    className="inline-block px-2 py-0.5 rounded-full text-[9px] font-medium leading-tight flex-shrink-0"
                                                    style={{
                                                      backgroundColor:
                                                        badgeStyle.bg,
                                                      color: badgeStyle.text,
                                                      border: `1px solid ${badgeStyle.border}`,
                                                    }}
                                                  >
                                                    {label}
                                                  </span>
                                                );
                                              })()}
                                          </div>
                                        </td>
                                        <td className="px-3 py-2 text-slate-500">
                                          {item.missionLabel}
                                        </td>
                                        <td className="px-3 py-2 text-slate-500">
                                          <span className="line-clamp-1">
                                            {item.descriptif || "-"}
                                          </span>
                                        </td>
                                        <td className="px-3 py-2 text-slate-500">
                                          {formatDate(item.createdAt)}
                                        </td>
                                        <td
                                          className={`px-3 py-2 font-medium ${
                                            isOverdue
                                              ? "text-red-600"
                                              : "text-slate-500"
                                          }`}
                                        >
                                          {formatDate(item.dueDate)}
                                        </td>
                                        <td className="px-3 py-2">
                                          <span
                                            className={`px-1.5 py-0.5 rounded text-xs font-semibold ${
                                              item.priority === "élevé"
                                                ? "bg-red-100 text-red-700"
                                                : "bg-slate-100 text-slate-600"
                                            }`}
                                          >
                                            {item.priority || "-"}
                                          </span>
                                        </td>
                                        {[
                                          "ADMINISTRATEUR",
                                          "EXPERT_COMPTABLE",
                                        ].includes(utilisateur.role) && (
                                          <td className="px-3 py-2 text-slate-500">
                                            {item.coefficient != null
                                              ? item.coefficient
                                              : "-"}
                                          </td>
                                        )}
                                      </tr>
                                    )}
                                  </Draggable>
                                );
                              })}
                              {provided.placeholder}
                            </tbody>
                          )}
                        </Droppable>
                      </table>
                    )}
                  </div>
                );
              })}
          </div>
          <br />

          {selectedItems.length > 0 && (
            <div className="ClientOption">
              <div className="COption">
                {/* Nombre de dossiers sélectionnés */}
                <div className="IdL">
                  <p>{selectedItems.length}</p>
                </div>

                {/* Boutons d'action */}
                <div className="flex gap-8 p-2 items-center justify-center">
                  {/* Archiver / Désarchiver */}
                  <p style={{ color: "black" }}>Dossier sélectionné(e)</p>
                  {!showArchives ? (
                    <button
                      onClick={handleMultiArchive}
                      className="flex flex-col items-center justify-center bg-white text-black border border-slate-300 rounded-md py-1 px-2 hover:bg-slate-50 transition text-xs font-semibold"
                    >
                      <HiMiniArchiveBox size={16} />
                      <p>{isArchiving ? "Archivage..." : "Archiver"}</p>
                    </button>
                  ) : (
                    <button
                      onClick={handleMultiUnarchive}
                      className="flex flex-col items-center justify-center bg-white text-black border border-slate-300 rounded-md py-1 px-2 hover:bg-slate-50 transition text-xs font-semibold"
                    >
                      <HiMiniArchiveBox size={16} />
                      <p>
                        {isDesArchiving ? "Désarchivage..." : "Désarchiver"}
                      </p>
                    </button>
                  )}

                  {/* Supprimer */}
                  <button
                    onClick={handleMultiDelete}
                    className="flex flex-col items-center justify-center bg-red-50 text-red-700 border border-red-300 rounded-md py-1 px-2 hover:bg-red-100 transition text-xs font-semibold"
                  >
                    <AiOutlineDelete size={16} />
                    <p>{isDeleting ? "Suppression..." : "Supprimer"}</p>
                  </button>
                </div>
              </div>
            </div>
          )}

          {showAddDiv && (
            <div className="overlayAC">
              <div className="inoverlayMS">
                <button
                  className="close-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    setshowAddDiv(false);
                  }}
                  style={{
                    position: "absolute",
                    top: "12px",
                    right: "12px",
                    background: "transparent",
                    border: "none",
                    fontSize: "24px",
                    cursor: "pointer",
                    zIndex: 10000,
                  }}
                >
                  <button
                    aria-label="Fermer"
                    className="p-2 rounded-md text-gray-500 hover:text-gray-800 bg-gray-200 transition"
                  >
                    <X className="w-4 h-4" />
                  </button>
                </button>
                <Mission onCancel={() => setshowAddDiv(false)} />
              </div>
            </div>
          )}

          {/* ===== OVERLAY DOSSIER LEAD ===== */}
          {overlayDossier && dossierType === "lead" && (
            <div className="overlayAC" ref={overlayDossierRef}>
              <div className="inoverlayLead" ref={inoverlayDossierRef}>
                <button
                  className="close-button"
                  onClick={() => setOverlayDossier(null)}
                  style={{
                    position: "absolute",
                    top: "12px",
                    right: "12px",
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    zIndex: 10000,
                  }}
                >
                  <button
                    aria-label="Fermer"
                    className="p-2 rounded-md text-gray-500 hover:text-gray-800 bg-gray-200 transition"
                  >
                    <X className="w-4 h-4" />
                  </button>
                </button>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    padding: "0 5%",
                    boxSizing: "border-box",
                  }}
                >
                  {/* Header lead */}
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-[#9B1B5D] to-[#7A1548] flex items-center justify-center flex-shrink-0">
                      <Building2 className="w-7 h-7 text-white" />
                    </div>
                    <div>
                      <div className="text-xl font-bold text-slate-900">
                        {overlayDossier.prenom} {overlayDossier.nom}
                      </div>
                      <div className="flex items-center gap-2 mt-1">
                        <span className="px-2 py-1 text-xs font-semibold rounded-md border bg-yellow-100 text-yellow-800 border-yellow-300">
                          Prospect
                        </span>
                        {overlayDossier.formeSociale && (
                          <span className="text-xs text-slate-500">
                            {overlayDossier.formeSociale}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Informations contact */}
                    <div className="bg-white rounded-lg p-4 border border-slate-200">
                      <h3 className="text-sm font-semibold text-slate-900 mb-3 flex items-center gap-2">
                        <User className="w-4 h-4 text-[#9B1B5D]" />
                        Informations contact
                      </h3>
                      <div className="space-y-2">
                        {[
                          { label: "Civilité", val: overlayDossier.civilite },
                          { label: "Nom", val: overlayDossier.nom },
                          { label: "Prénom", val: overlayDossier.prenom },
                          { label: "Email", val: overlayDossier.mail },
                          { label: "Téléphone", val: overlayDossier.tel },
                          { label: "Adresse", val: overlayDossier.adresse },
                        ]
                          .filter((r) => r.val)
                          .map(({ label, val }) => (
                            <div
                              key={label}
                              className="flex justify-between text-xs"
                            >
                              <span className="text-slate-500">{label}</span>
                              <span className="font-medium text-slate-900 text-right max-w-[55%]">
                                {val}
                              </span>
                            </div>
                          ))}
                      </div>
                    </div>

                    {/* Informations société + RDV */}
                    <div className="space-y-4">
                      {(overlayDossier.societeNom ||
                        overlayDossier.formeSociale ||
                        overlayDossier.sirenSociete) && (
                        <div className="bg-white rounded-lg p-4 border border-slate-200">
                          <h3 className="text-sm font-semibold text-slate-900 mb-3 flex items-center gap-2">
                            <Briefcase className="w-4 h-4 text-[#9B1B5D]" />
                            Société
                          </h3>
                          <div className="space-y-2">
                            {[
                              {
                                label: "Dénomination",
                                val: overlayDossier.societeNom,
                              },
                              {
                                label: "Forme sociale",
                                val: overlayDossier.formeSociale,
                              },
                              {
                                label: "SIREN",
                                val: overlayDossier.sirenSociete,
                              },
                            ]
                              .filter((r) => r.val)
                              .map(({ label, val }) => (
                                <div
                                  key={label}
                                  className="flex justify-between text-xs"
                                >
                                  <span className="text-slate-500">
                                    {label}
                                  </span>
                                  <span className="font-medium text-slate-900">
                                    {val}
                                  </span>
                                </div>
                              ))}
                          </div>
                        </div>
                      )}

                      {overlayDossier.objetRDV && (
                        <div className="bg-white rounded-lg p-4 border border-slate-200">
                          <h3 className="text-sm font-semibold text-slate-900 mb-3 flex items-center gap-2">
                            <Calendar className="w-4 h-4 text-[#9B1B5D]" />
                            Rendez-vous
                          </h3>
                          <div className="space-y-2 text-xs">
                            <div className="flex justify-between">
                              <span className="text-slate-500">Objet</span>
                              <span className="font-medium text-slate-900 text-right max-w-[55%]">
                                {overlayDossier.objetRDV}
                              </span>
                            </div>
                            {overlayDossier.dateRDV && (
                              <div className="flex justify-between">
                                <span className="text-slate-500">Date</span>
                                <span className="font-medium text-slate-900">
                                  {new Date(
                                    overlayDossier.dateRDV
                                  ).toLocaleDateString("fr-FR", {
                                    day: "numeric",
                                    month: "long",
                                    year: "numeric",
                                  })}
                                  {overlayDossier.heureRDV &&
                                    ` à ${overlayDossier.heureRDV}`}
                                </span>
                              </div>
                            )}
                            {overlayDossier.lieuRDV && (
                              <div className="flex justify-between">
                                <span className="text-slate-500">Lieu</span>
                                <span className="font-medium text-slate-900 text-right max-w-[55%]">
                                  {overlayDossier.lieuRDV}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      )}

                      {overlayDossier.user && (
                        <div className="bg-[#9B1B5D]/5 rounded-lg p-3 flex items-center gap-3">
                          <div className="w-8 h-8 rounded-full bg-[#9B1B5D] flex items-center justify-center flex-shrink-0">
                            <User className="w-4 h-4 text-white" />
                          </div>
                          <div>
                            <p className="text-xs text-slate-500">
                              Collaborateur référent
                            </p>
                            <p className="text-xs font-semibold text-slate-900">
                              {overlayDossier.user.name}{" "}
                              {overlayDossier.user.lastName}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <br />
                  <br />
                </div>
              </div>
            </div>
          )}

          {/* ===== OVERLAY DOSSIER HORS BASE (creationsct sans lead ni client) ===== */}
          {overlayDossier && dossierType === "inconnu" && (
            <div className="overlayAC" ref={overlayDossierRef}>
              <div className="inoverlayLead" ref={inoverlayDossierRef}>
                <button
                  className="close-button"
                  onClick={() => setOverlayDossier(null)}
                  style={{
                    position: "absolute",
                    top: "12px",
                    right: "12px",
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    zIndex: 10000,
                  }}
                >
                  <button
                    aria-label="Fermer"
                    className="p-2 rounded-md text-gray-500 hover:text-gray-800 bg-gray-200 transition"
                  >
                    <X className="w-4 h-4" />
                  </button>
                </button>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    padding: "0 5%",
                    boxSizing: "border-box",
                  }}
                >
                  {/* Header */}
                  <div className="flex items-center gap-4 mb-4">
                    <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-slate-500 to-slate-700 flex items-center justify-center flex-shrink-0">
                      <Building2 className="w-7 h-7 text-white" />
                    </div>
                    <div>
                      <div className="text-xl font-bold text-slate-900">
                        {overlayDossier.nomSociete ||
                          overlayDossier.nomCommercial ||
                          "Dossier sans nom"}
                      </div>
                      <div className="flex items-center gap-2 mt-1">
                        <span className="px-2 py-1 text-xs font-semibold rounded-md border bg-slate-100 text-slate-600 border-slate-300">
                          Hors base
                        </span>
                        {overlayDossier.formeSociale && (
                          <span className="text-xs text-slate-500">
                            {overlayDossier.formeSociale}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Notice hors base */}
                  <div className="flex items-start gap-3 bg-amber-50 border border-amber-200 rounded-lg p-3 mb-6">
                    <AlertCircle className="w-4 h-4 text-amber-600 flex-shrink-0 mt-0.5" />
                    <p className="text-xs text-amber-800 m-0">
                      Ce dossier n&apos;est pas — ou pas encore — enregistré
                      dans la base de données du système : aucune fiche client
                      ni lead n&apos;y est associée. Les informations affichées
                      proviennent uniquement du formulaire de création de
                      société.
                    </p>
                  </div>

                  {overlayDossier.envelope && (
                    <div className="bg-white rounded-lg p-4 border border-slate-200 mb-6">
                      <h3 className="text-sm font-semibold text-slate-900 mb-3 flex items-center gap-2">
                        <User className="w-4 h-4 text-[#9B1B5D]" />
                        Contact
                      </h3>
                      <div className="space-y-2">
                        {[
                          {
                            label: "Civilité",
                            val: overlayDossier.envelope.civilite_lm,
                          },
                          { label: "Nom", val: overlayDossier.envelope.nom },
                          {
                            label: "Prénom",
                            val: overlayDossier.envelope.prenom,
                          },
                          {
                            label: "Email",
                            val: overlayDossier.envelope.email,
                          },
                          {
                            label: "Téléphone",
                            val: overlayDossier.envelope.telephone,
                          },
                        ]
                          .filter((r) => r.val)
                          .map(({ label, val }) => (
                            <div
                              key={label}
                              className="flex justify-between text-xs"
                            >
                              <span className="text-slate-500">{label}</span>
                              <span className="font-medium text-slate-900 text-right max-w-[55%]">
                                {val}
                              </span>
                            </div>
                          ))}
                      </div>
                    </div>
                  )}

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Société */}
                    <div className="bg-white rounded-lg p-4 border border-slate-200">
                      <h3 className="text-sm font-semibold text-slate-900 mb-3 flex items-center gap-2">
                        <Briefcase className="w-4 h-4 text-[#9B1B5D]" />
                        Société
                      </h3>
                      <div className="space-y-2">
                        {[
                          {
                            label: "Dénomination",
                            val: overlayDossier.nomSociete,
                          },
                          {
                            label: "Nom commercial",
                            val: overlayDossier.nomCommercial,
                          },
                          {
                            label: "Forme sociale",
                            val: overlayDossier.formeSociale,
                          },
                          {
                            label: "Type social",
                            val: overlayDossier.typeSocial,
                          },
                          { label: "Capital", val: overlayDossier.capital },
                          { label: "Banque", val: overlayDossier.banque },
                          {
                            label: "Siège social",
                            val: overlayDossier.siegeSocial,
                          },
                          {
                            label: "Complément d'adresse",
                            val: overlayDossier.adresse_complement,
                          },
                          {
                            label: "Code postal",
                            val: overlayDossier.codePostal,
                          },
                          { label: "Ville", val: overlayDossier.ville },
                          {
                            label: "Secteur d'activité",
                            val: overlayDossier.secteurActivite,
                          },
                          { label: "Activité", val: overlayDossier.activite },
                        ]
                          .filter((r) => r.val)
                          .map(({ label, val }) => (
                            <div
                              key={label}
                              className="flex justify-between text-xs"
                            >
                              <span className="text-slate-500">{label}</span>
                              <span className="font-medium text-slate-900 text-right max-w-[55%]">
                                {val}
                              </span>
                            </div>
                          ))}
                      </div>
                    </div>

                    {/* Fiscalité & mission */}
                    <div className="bg-white rounded-lg p-4 border border-slate-200">
                      <h3 className="text-sm font-semibold text-slate-900 mb-3 flex items-center gap-2">
                        <Calendar className="w-4 h-4 text-[#9B1B5D]" />
                        Fiscalité &amp; mission
                      </h3>
                      <div className="space-y-2">
                        {[
                          {
                            label: "Régime fiscal",
                            val: overlayDossier.regimeFiscal,
                          },
                          {
                            label: "Régime TVA",
                            val: overlayDossier.regimeTVA,
                          },
                          {
                            label: "Date de clôture",
                            val: overlayDossier.dateCloture
                              ? formatDate(overlayDossier.dateCloture)
                              : null,
                          },
                          { label: "Statut", val: overlayDossier.status },
                          { label: "Priorité", val: overlayDossier.priority },
                          {
                            label: "Échéance",
                            val: overlayDossier.dueDate
                              ? formatDate(overlayDossier.dueDate)
                              : null,
                          },
                          {
                            label: "Coefficient",
                            val: overlayDossier.coefficient,
                          },
                          {
                            label: "Créé le",
                            val: overlayDossier.createdAt
                              ? formatDate(overlayDossier.createdAt)
                              : null,
                          },
                        ]
                          .filter((r) => r.val)
                          .map(({ label, val }) => (
                            <div
                              key={label}
                              className="flex justify-between text-xs"
                            >
                              <span className="text-slate-500">{label}</span>
                              <span className="font-medium text-slate-900 text-right max-w-[55%]">
                                {val}
                              </span>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>

                  {/* Associés */}
                  {overlayDossier.associes?.length > 0 && (
                    <div className="bg-white rounded-lg p-4 border border-slate-200 mt-6">
                      <h3 className="text-sm font-semibold text-slate-900 mb-3 flex items-center gap-2">
                        <User className="w-4 h-4 text-[#9B1B5D]" />
                        Associés
                      </h3>
                      <div className="space-y-2.5">
                        {overlayDossier.associes.map((assoc) => (
                          <div
                            key={assoc.id}
                            className="flex items-center gap-2 p-2 bg-[#9B1B5D]/5 rounded-lg"
                          >
                            <div className="w-8 h-8 rounded-full bg-[#9B1B5D] flex items-center justify-center flex-shrink-0">
                              <User className="w-4 h-4 text-white" />
                            </div>
                            <div className="flex-1 min-w-0">
                              <p className="text-xs font-semibold text-slate-900 truncate m-0">
                                {assoc.nomAssocie || "-"}
                                {assoc.dirigeant && (
                                  <span className="ml-2 px-1.5 py-0.5 rounded-full text-[9px] font-medium bg-emerald-100 text-emerald-700 border border-emerald-200">
                                    Dirigeant
                                  </span>
                                )}
                              </p>
                              <p className="text-xs text-slate-500 truncate m-0">
                                {[assoc.emailAssocie, assoc.telephoneAssocie]
                                  .filter(Boolean)
                                  .join(" · ") || " "}
                              </p>
                            </div>
                            {assoc.pourcentage != null && (
                              <span className="text-xs font-semibold text-[#9B1B5D] flex-shrink-0">
                                {assoc.pourcentage}%
                              </span>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  <br />
                  <br />
                </div>
              </div>
            </div>
          )}

          <FicheClientOverlay
            client={ficheClientData}
            open={ficheClientOpen}
            loading={ficheClientLoading}
            initialTab="general"
            onClose={() => setFicheClientOpen(false)}
            onClientUpdated={handleUpdateClientInList}
          />

          {showDetails &&
            selectedItem &&
            (selectedSource === "droitsoc" ? (
              <DroitscoDetails
                item={selectedItem}
                setItem={setSelectedItem}
                onClose={handleCloseDetails}
                fetchData={fetchData}
                onItemUpdate={updateLocalData}
              />
            ) : selectedSource === "modifsct" ? (
              <ModificationSociete
                item={selectedItem}
                setItem={setSelectedItem}
                onClose={handleCloseDetails}
                fetchData={fetchData}
                onItemUpdate={updateLocalData}
              />
            ) : selectedSource === "radiation" ? (
              <Radiation
                item={selectedItem}
                setItem={setSelectedItem}
                onClose={handleCloseDetails}
                fetchData={fetchData}
                onItemUpdate={updateLocalData}
              />
            ) : selectedSource === "autresMission" ? (
              <Autre
                item={selectedItem}
                setItem={setSelectedItem}
                onClose={handleCloseDetails}
                fetchData={fetchData}
                onItemUpdate={updateLocalData}
              />
            ) : (
              <CreateSociete
                item={selectedItem}
                setItem={setSelectedItem}
                onClose={handleCloseDetails}
                fetchData={fetchData}
                onItemUpdate={updateLocalData}
              />
            ))}
        </>
        {/* )} */}
      </div>
    </DragDropContext>
  );
};

export default JuridiquePonctuelle;
